// Thin wrapper over gtag. The tag itself is loaded in index.html (and in the
// static marketing template) — guarded off on localhost, so these helpers are
// safe no-ops in dev.

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

export const GA_MEASUREMENT_ID = 'G-JHF3WTE44Z';

export function trackEvent(name: string, params?: Record<string, unknown>) {
  window.gtag?.('event', name, params);
}

// GA4 only fires page_view on full page loads; SPAs must report route changes.
export function trackPageView(path: string) {
  window.gtag?.('event', 'page_view', {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
  });
}
